import React, { useMemo, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import NavBar from '../components/NavBar';
import Footer from '../components/Footer';
import './SimulationsPage.css';

import deliveryImg from './images/delivery.jpg';     // VRP
import warehouseImg from './images/warehouse.jpg';   // TP
import tspImg from './images/tsp.jpg';
import sppImg from './images/spp.jpg';
import mmoImg from './images/mmo.jpg';

const ALL_SIMULATIONS = [
  {
    id: 'vrp',
    title: 'Vehicle Routing Problem (VRP)',
    description: 'Simulate route planning with capacity constraints using the Saving Algorithm.',
    route: '/vrp',
    level: 'Intermediate',
    image: deliveryImg, // keep
    isNew: false,
  },
  {
    id: 'tsp',
    title: 'Travelling Salesman Problem (TSP)',
    description: 'Explore the shortest circular route covering all points using step-by-step logic.',
    route: '/tsp',
    level: 'Beginner',
    image: tspImg, // use NEW image
    isNew: false,
  },
  {
    id: 'spp',
    title: 'Shortest Path Problem (SPP)',
    description: "Understand Dijkstra's algorithm interactively on predefined network graphs.",
    route: '/spp',
    level: 'Beginner',
    image: sppImg, // use NEW image
    isNew: false,
  },
  {
    id: 'tp',
    title: 'Transportation Problem (TP)',
    description: 'Visualize how goods are allocated from sources to destinations with costs.',
    route: '/tp',
    level: 'Intermediate',
    image: warehouseImg, // keep
    isNew: false,
  },
  {
    id: 'mmt',
    title: 'Multi-modal Optimization',
    description: 'Optimize transport across various modes (air, road, rail) with constraints.',
    route: '/multi-modal',
    level: 'Advanced',
    image: mmoImg, // use NEW image
    isNew: false,
  },
];


const LEVELS = ['All', 'Beginner', 'Intermediate', 'Advanced'];

export default function SimulationsPage() {
  const navigate = useNavigate();
  const [q, setQ] = useState('');
  const [level, setLevel] = useState('All');

  const filtered = useMemo(() => {
    const qNorm = q.trim().toLowerCase();
    return ALL_SIMULATIONS.filter(s => {
      const levelOk = level === 'All' || s.level === level;
      const textOk =
        !qNorm ||
        s.title.toLowerCase().includes(qNorm) ||
        s.description.toLowerCase().includes(qNorm);
      return levelOk && textOk;
    });
  }, [q, level]);

  return (
    <div className="simulations-container">
      <NavBar />

      <div className="simulations-content">
        <h1 className="simulations-title">Simulations</h1>

        {/* Controls */}
        <div className="sim-controls">
          <input
            className="sim-search"
            type="search"
            placeholder="Search simulations…"
            value={q}
            onChange={(e) => setQ(e.target.value)}
            aria-label="Search simulations"
          />
        </div>

        <div className="simulations-grid">
          {filtered.map(sim => (
            <article key={sim.id} className="simulation-card">
              <button
                className="card-link"
                onClick={() => navigate(sim.route)}
                aria-label={`Open ${sim.title}`}
              >
                <div className="image-wrap">
                  <img
                    src={sim.image}
                    alt={sim.title}
                    loading="lazy"
                    className="simulation-img"
                  />
                  <div className="img-gradient" />
                  {sim.isNew && <span className="badge-new">New</span>}
                </div>

                <div className="card-body">
                  <h2 className="simulation-title">{sim.title}</h2>
                  <p className="simulation-description">{sim.description}</p>

                  <div className="simulation-footer">
                    <span className="explore-cta">Explore →</span>
                  </div>
                </div>
              </button>
            </article>
          ))}
        </div>

        {filtered.length === 0 && (
          <p className="empty-hint">No results. Try clearing the search or changing the level.</p>
        )}
      </div>

      <Footer />
    </div>
  );
}